// block ios gestures (this prevents iOS10 resizing)
document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
});

$(function() {
  var body = $('body');

  var activeTab = $('.navbar.tabbed li.active');

  if (activeTab.length > 0) {
    activeTab.animateScroll(1000, {
      parent: true,
      scroll: 'left'
    });
  }

  // quick svg fallback
  if (!Modernizr.svg) {
    $('img[src*="svg"]').attr('src', function() {
      return $(this).attr('src').replace('.svg', '.png');
    });
  }

  // embed modal close button
  $('.modal-embed .btn-close').on('click.av', function() {
    var url = $(this).data('url') || '/';
    window.location = url;
    return false;
  });

  // auto open modals
  $('.auto-open').each(function() {
    $(this).modal('show');
  });

  // only one open modal at a time
  $('.modal').on('shown.bs.modal', function(e) {
    var selector = '#' + $(this).attr('id');

    AVState.push({
      toggle: 'modal',
      selector: selector,
      url: selector
    });
    
    var stackedModals = $('.modal:visible').not($(this));
    if (stackedModals.length) {
      stackedModals.modal('hide');
    }
  });

  // only one open modal at a time
  $('.modal').on('hide.bs.modal', function(e) {
    var stackedModals = $('.modal:visible').not($(this));
    if (!stackedModals.length && AVState.current.toggle === 'modal') {
      AVState.pop();
    }
  });

  var dropdowns = $('.dropdown.overlay');
  
  dropdowns.on('show.bs.dropdown', function() {
    body.addClass('content-overlay');
  });
  
  dropdowns.on('hide.bs.dropdown', function() {
    body.removeClass('content-overlay');
  });

  // init tooltips, click to show, active toggles
  $('[data-toggle="tooltip"]').avTooltip();

  // toggle switched
  $('.sb-toggle input').change(function() {
    var active = $(this).is(':checked');
    if(active) {
      $(this).closest('.sb-toggle').addClass('active').find('.text').text('on');
    } else {
      $(this).closest('.sb-toggle').removeClass('active').find('.text').text('off');
    }
  });

  // move to end of text for auto-focused inputs
  $('input[autofocus]').on('focus', function() {
    var val = $(this).val();
    if(val.length > 0) {
      $(this).val(val);
    }
  });

  // range selectors
  $('.range').each(function() {
    var $input = $(this).find('.input > span');
    var $low = $(this).find('.low');
    var $high = $(this).find('.high');

    var min = parseInt($high.attr('min'));
    var max = parseInt($high.attr('max'));

    // setup slider
    $input.slider({
      range: true,
      min: min,
      max: max,
      values: [$low.val(), $high.val()],
      disabled: $low.is(':disabled') || $high.is(':disabled'),
      slide: function(e, ui) {
        $low.val(ui.values[0]);
        $high.val(ui.values[1]);
      }
    });

    var updateRange = function() {
      var low = parseInt($low.val());
      var high = parseInt($high.val());
      var oob = isNaN(low)  || low < min  || low > high || low > max ||
                isNaN(high) || high < min || high < low || high > max;
      if (oob) {
        low = max;
        high = max;
      }
      var sliderLow = $input.slider('values', 0);
      var sliderHigh = $input.slider('values', 1);
      if (sliderLow !== low) $input.slider('values', 0, low);
      if (sliderHigh !== high) $input.slider('values', 1, high);
      $low.val(low);
      $high.val(high);
    }

    // manual low change
    $low.keyup(debounce(function() {
      if(this.value.length == 0) return;
      $low.val(this.value).trigger('change');
    }, 2000));
    $low.change(updateRange);

    // manual high change
    $high.keyup(debounce(function() {
      if(this.value.length == 0) return;
      $high.val(this.value).trigger('change');
    }, 2000));
    $high.change(updateRange);

  });

  // banners set to auto close
  $('.banner[data-auto-close]:visible').each(function() {
    var banner = $(this);
    var close = banner.find('.btn-close');
    var timeout = banner.data('autoClose');

    setTimeout(function() {
      close.click();
    }, timeout);
  });

  // Add browser state listeners
  AVState.addListener('push', function(state) {
    if (state.toggle === 'modal') {
      var modal = $(state.selector);
      var data = modal.data('bs.modal');
      if (!(data && data.isShown)) {
        $(state.selector).modal('show');
      }
    }
  });

  AVState.addListener('pop', function(state) {
    if (state.toggle === 'modal') {
      var modal = $(state.selector);
      var data = modal.data('bs.modal');
      if (data && data.isShown) {
        modal.modal('hide');
      }
    }
  });

  // Initialize browser state
  AVState.init({
    alwaysReplace: function(state) {
      return AVState.current.url ? true : false;
    }
  });
});
